import React, { useEffect, useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { FaBirthdayCake, FaClock, FaGift, FaHeart } from 'react-icons/fa';

const calculateTimeLeft = (targetDate) => {
  const difference = targetDate - new Date();
  if (difference <= 0) {
    return {};
  }
  return {
    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((difference / 1000 / 60) % 60),
    seconds: Math.floor((difference / 1000) % 60),
  };
};

const iconMap = [FaHeart, FaGift, FaBirthdayCake, FaClock];

const Countdown = ({ targetDate, title, helperText, onCountdownEnd }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(targetDate));

  useEffect(() => {
    const timer = setTimeout(() => {
      const updated = calculateTimeLeft(targetDate);
      setTimeLeft(updated);
      if (!updated || Object.keys(updated).length === 0) {
        onCountdownEnd();
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [onCountdownEnd, targetDate, timeLeft]);

  const timeEntries = useMemo(() => Object.entries(timeLeft), [timeLeft]);

  return (
    <div className="birthday-countdown">
      <motion.h1
        className="birthday-countdown-title"
        initial={{ scale: 0.96 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.4, repeat: Infinity, repeatType: 'reverse' }}
      >
        {title}
      </motion.h1>

      <div className="birthday-countdown-grid">
        {timeEntries.length ? (
          timeEntries.map(([unit, value], index) => {
            const Icon = iconMap[index % iconMap.length];
            return (
              <motion.div
                key={unit}
                className="birthday-countdown-item"
                initial={{ y: 16, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ duration: 0.45, delay: index * 0.08 }}
              >
                <span className="birthday-countdown-value">{value}</span>
                <span className="birthday-countdown-unit">{unit}</span>
                <Icon />
              </motion.div>
            );
          })
        ) : (
          <p className="birthday-countdown-ready">It is celebration time!</p>
        )}
      </div>

      {helperText ? (
        <motion.p
          className="birthday-countdown-helper"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.25 }}
        >
          {helperText}
        </motion.p>
      ) : null}
    </div>
  );
};

export default Countdown;
